// helpers
import { transformDeliveryText } from 'shared/store/transformer/transform';

// types
import { ServiceabilityDataObj } from 'shared/types/cart';
import get from 'lodash/get';
import set from 'lodash/set';

export const minDeliveryOrShippingDay = (
  data: ServiceabilityDataObj,
  freeDeliveryAvailable: boolean
) => {
  let skuWithMinShippingDays = '';
  let skuWithMinDeliveryDays = '';
  let minDeliveryDays = Number.MAX_SAFE_INTEGER;
  let minShippingDays = Number.MAX_SAFE_INTEGER;

  for (const key in data) {
    if (data[key].o2dTat !== null && minDeliveryDays > data[key].o2dTat) {
      skuWithMinDeliveryDays = key;
      minDeliveryDays = data[key].o2dTat;
    }

    if (data[key].o2sTat !== null && minShippingDays > data[key].o2sTat) {
      skuWithMinShippingDays = key;
      minShippingDays = data[key].o2sTat;
    }
  }

  // since minDeliveryDays === Number.MAX_SAFE_INTEGER that means, we have
  // delivery date as null because user do not have saved pincode
  // so will return min shipping date
  if (minDeliveryDays === Number.MAX_SAFE_INTEGER) {
    return transformDeliveryText(data, skuWithMinShippingDays, freeDeliveryAvailable);
  }

  // return min shipping date
  return transformDeliveryText(data, skuWithMinDeliveryDays, freeDeliveryAvailable);
};

export function getUpdatedCustomisationData({ customisationData, index, values = {} }) {
  const previousSectionObject = get(customisationData, `sections[${index}]`);
  return set(customisationData, `sections[${index}]`, {
    ...previousSectionObject,
    ...values,
  });
}
